import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import Parse from "parse";
import { JoyrideComponent, stepsComponent } from "./JoyrideComponent";
import {
  showProfileSidebar,
  showQRQueueModal,
  showOrganizationSidebar,
  setQRQueueModalTab,
  setQRQueueModalDemo,
} from "../../actions/GlobalAction";
import { setActiveTab } from "../../actions/ThreadAction";
import {
  styles,
  rawStepsMainView,
  rawStepsDrawerView,
  rawStepsQrCodeView,
  rawStepsOrgView,
  rawStepsMainViewTest,
} from "./steps";

const AppDemo = () => {
  const dispatch = useDispatch();

  const {
    profileSidebarShown,
    qrCodeModalShown,
    organizationSettingShown,
  } = useSelector(
    (state) => ({
      profileSidebarShown: state.global.profileSidebarShown,
      qrCodeModalShown: state.global.qrCodeModalShown,
      organizationSettingShown: state.global.organizationSettingShown,
    }),
    shallowEqual,
  );

  const uuid = Parse.User.current() ? Parse.User.current().id : "";
  const idAppDemoMain = "hubchart-app-demo-main-view-" + uuid;
  const idAppDemoDrawer = "hubchart-app-demo-drawer-view-" + uuid;
  const idAppDemoQrCode = "hubchart-app-demo-code-view-" + uuid;
  const idAppDemoOrg = "hubchart-app-demo-org-view-" + uuid;
  
  const [runMainView, setRunMainView] = useState(false);
  const [runDrawerView, setRunDrawerView] = useState(false);
  const [runQrCodeView, setRunQrCodeView] = useState(false);
  const [runOrganizationView, setRunOrganizationView] = useState(false);

  const [currentIndexQrCode, setCurrentIndexQrCode] = useState(0);
  const [currentIndexOrg, setCurrentIndexOrg] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);

  const hasMainView = localStorage.getItem(idAppDemoMain) || false;
  const hasDrawerView = localStorage.getItem(idAppDemoDrawer) || false;
  const hasQrCodeView = localStorage.getItem(idAppDemoQrCode) || false;
  const hasOrganizationView = localStorage.getItem(idAppDemoOrg) || false;

  const stepsMainView = useMemo(() => rawStepsMainView.map(step => stepsComponent(step)), []);
  const stepsDrawerView = useMemo(() => rawStepsDrawerView.map(step => stepsComponent(step)), []);
  const stepsQrCodeView = useMemo(() => rawStepsQrCodeView.map(step => stepsComponent(step)), []);
  const stepsOrgView = useMemo(() => rawStepsOrgView.map(step => stepsComponent(step)), []);

  // ORGANIZATION SETTING IN APP DEMO START
  useEffect(() => {
    if (!organizationSettingShown) return;
    if (hasOrganizationView) return;
    console.log("trigger org timer");
    const timer = setTimeout(() => {
      setRunOrganizationView(true);
    }, 1000);
    return () => clearTimeout(timer);

  }, [organizationSettingShown]);

  // DRAWER IN APP DEMO START
  useEffect(() => {
    if (!profileSidebarShown) return;
    if (hasDrawerView) return;

    const timer = setTimeout(() => {
      setRunDrawerView(true);
    }, 1000);
    return () => clearTimeout(timer);

  }, [profileSidebarShown]);

  // QR CODE MODAL IN APP DEMO START
  useEffect(() => {
    if (!qrCodeModalShown) return;
    if (hasQrCodeView) return;

    const timer = setTimeout(() => {
      setRunQrCodeView(true);
    }, 500);
    return () => clearTimeout(timer);

  }, [qrCodeModalShown]);

  const handleOpenProfileSidebar = () => {
    dispatch(showProfileSidebar());
  };

  // MAIN IN APP DEMO START
  useEffect(() => {
    if (!hasMainView) {
      const element = document.querySelector("#hc-nav-tab-inbox");

      if (element) {
        dispatch(setActiveTab("message"));
        setRunMainView(true);
      } else {
        const timer = setTimeout(() => {
          if (document.querySelector("#hc-nav-tab-inbox")) {
            dispatch(setActiveTab("message"));
            setRunMainView(true);
          } else {
            console.warn(
              "Joyride: Target #hc-nav-tab-inbox not found on page.",
            );
          }
        }, 2000);
        return () => clearTimeout(timer);
      }
    }
  }, []);

  const handleAppDemoCallback = (data, idLocalStorage) => {
    const { status, index, type, action } = data;
    
    if (status === "finished" || status === "skipped") {
      localStorage.setItem(idLocalStorage, true);
      setRunMainView(false);
      setRunDrawerView(false);
      setRunOrganizationView(false);
      return;
    }
    if (idLocalStorage === idAppDemoQrCode && type === "tour:status" && index === 0 && action === "reset") {
      setRunQrCodeView(false);
      dispatch(setQRQueueModalDemo(false));
      return;
    }
    if (idLocalStorage === idAppDemoQrCode && type === "step:after") {
      
      if (index === 5) {
        dispatch(setQRQueueModalDemo(false));
      }
      if (index === 1) {
        setRunQrCodeView(false);
        dispatch(setQRQueueModalTab("CURRENT"));
        
        setTimeout(() => {
          setCurrentIndexQrCode(2);
          setRunQrCodeView(true);
        }, 500);
      }
      if (index === 3) {
        setRunQrCodeView(false);
        dispatch(setQRQueueModalTab("LIST"));
        
        setTimeout(() => {
          setCurrentIndexQrCode(4);
          setRunQrCodeView(true);
        }, 500);
      }
    }
    if (idLocalStorage === idAppDemoOrg && prevIndex === stepsOrgView.length - 1 && index === 0) {
      dispatch(showOrganizationSidebar("demo-finished"));
    }
    if (idLocalStorage === idAppDemoOrg && type === "tooltip") {
      setPrevIndex(index);
    }
    if (idLocalStorage === idAppDemoOrg && type === "step:after") {
      if (index === 2) {
        dispatch(showOrganizationSidebar("add-modal"));
        setRunOrganizationView(false);
        
        setTimeout(() => {
          setCurrentIndexOrg(3);
          setRunOrganizationView(true);
        }, 500);
      }
      if (index === 3) {
        dispatch(showOrganizationSidebar("add-error"));
        setRunOrganizationView(false);
        
        setTimeout(() => {
          setCurrentIndexOrg(4);
          setRunOrganizationView(true);
        }, 500);
      }
      if (index === 4) {
        dispatch(showOrganizationSidebar("add-success"));
        setRunOrganizationView(false);
        
        setTimeout(() => {
          setCurrentIndexOrg(5);
          setRunOrganizationView(true);
        }, 500);
      }
      if (index === 5) {
        dispatch(showOrganizationSidebar("demo-leave"));
        setRunOrganizationView(false);
        
        setTimeout(() => {
          setCurrentIndexOrg(6);
          setRunOrganizationView(true);
        }, 500);
      }
    }
  };

  return (
    <>
      {/* APP DEMO PART 1 - MAIN PAGE */}
      <JoyrideComponent
        id={idAppDemoMain}
        steps={stepsMainView}
        run={runMainView}
        handleAppDemoCallback={handleAppDemoCallback}
      />
      {/* APP DEMO PART 2 - PROFILE DRAWER SETTING */}
      <JoyrideComponent
        id={idAppDemoDrawer}
        steps={stepsDrawerView}
        run={runDrawerView}
        handleAppDemoCallback={handleAppDemoCallback}
      />
      {/* APP DEMO PART 3 - QR CODE FEATURE */}
      <JoyrideComponent
        id={idAppDemoQrCode}
        steps={stepsQrCodeView}
        run={runQrCodeView}
        stepIndex={currentIndexQrCode}
        handleAppDemoCallback={handleAppDemoCallback}
      />
      {/* APP DEMO PART 4 - ORGANIZATION FEATURE */}
      <JoyrideComponent
        id={idAppDemoOrg}
        steps={stepsOrgView}
        run={runOrganizationView}
        stepIndex={currentIndexOrg}
        handleAppDemoCallback={handleAppDemoCallback}
      />
    </>
  );
};

export default AppDemo;
